import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="edit-input"
export default class extends Controller {
  static targets = ["previewText", "editText", "previewActions", "editActions", "beforeText", "input"]
  static values = {
    placeholder: String,
    beforeText: String,
    text: String
  }

  connect() {
    this.setPreviewText()
    window.addEventListener("resize", this.adjustInputWidth.bind(this))
  }

  setPreviewText() {
    const text = this.textValue || this.placeholderValue;
    this.previewTextTarget.textContent = this.beforeTextValue
      ? `${this.beforeTextValue}${text}`
      : text
  }

  toggleActions() {
    this.previewActionsTarget.classList.toggle("hidden")
    this.editActionsTarget.classList.toggle("hidden")
    this.editTextTarget.classList.toggle("hidden!")
    this.previewTextTarget.classList.toggle("hidden")

    if (!this.editTextTarget.classList.contains("hidden!")) {
      this.adjustInputWidth()
    }
  }

  adjustInputWidth() {
    if (!this.hasInputTarget || !this.hasBeforeTextTarget) return
    const parent = this.editTextTarget
    const beforeText = this.beforeTextTarget
    const input = this.inputTarget
    const gap = 8
    const rects = beforeText.getClientRects()
    if (!rects.length) return
    const lastRect = rects[rects.length - 1]
    const parentRect = parent.getBoundingClientRect()
    let inputWidth = parentRect.right - lastRect.right - gap
    inputWidth = Math.max(inputWidth, 80)
    input.style.width = `${inputWidth}px`
  }
}
